import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseGetWithoutParam,
  baseGetFile
} from 'services/base-services/baseService';
const baseURL = `${API2_HOST}/purchasing-histories`;

const getStockPurchases = async (year, selectedType) => {
  const res = await baseGetWithoutParam(`${baseURL}/stock-purchases/${year}/${selectedType}`);
  return res;
};
const getBeSpokePurchases = async (year, selectedType) => {
  const res = await baseGetWithoutParam(`${baseURL}/bespoke-purchases/${year}/${selectedType}`);
  return res;
};

const exportStockPurchases = async (fromDate, toDate, selectType) => {
  await baseGetFile(
    `${baseURL}/export/stock-purchases?fromDate=${fromDate}&toDate=${toDate}&selectType=${selectType}`,
    `StockPurchases_${fromDate}_${toDate}.xlsx`
  );
};

const exportBeSpokePurchases = async (fromDate, toDate, selectType) => {
  await baseGetFile(
    `${baseURL}/export/bespoke-purchases?fromDate=${fromDate}&toDate=${toDate}&selectType=${selectType}`,
    `BeSpokePurchases_${fromDate}_${toDate}.xlsx`
  );
};

export { getStockPurchases, getBeSpokePurchases, exportStockPurchases, exportBeSpokePurchases };
